import moment from 'moment-timezone';
import React from 'react';
import {useStationForecast} from '../hooks';
import {Dates, Forecast} from '../utils';

type MandatoryProps = {
  stationId: number;
};

const withForecastNextHours =
  <T extends MandatoryProps = MandatoryProps>(
    Component: React.ComponentType<T>,
  ) =>
  ({stationId, ...props}: T) => {
    const {
      forecastData: {
        data: {hourly},
        metadata,
      },
    } = useStationForecast(stationId);

    const hourlyForecast = React.useMemo(
      () =>
        hourly.filter(
          (f) =>
            Dates.now() < f.timestamp &&
            f.timestamp < moment().add(24, 'hours').unix(),
        ),
      [hourly],
    );

    const forecastModel = React.useMemo(
      () =>
        Forecast.SupportedForecastModelList.find(
          (item) =>
            item.serverId.forecastModel === metadata.forecast_model &&
            (item.serverId.meshSize === metadata.mesh_size ||
              item.serverId.meshSize === null),
        ),
      [metadata],
    );

    return (
      <Component
        hourlyForecast={hourlyForecast}
        forecastModel={forecastModel}
        forecastModelMetadata={metadata}
        stationId={stationId}
        {...(props as T)}
      />
    );
  };

export default withForecastNextHours;
